import { fromEvent } from 'rxjs'
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { EventBroadcastService } from '../../../services/event-broadcast.service';
import { ProtuneApiService } from '../../../services/protune-api.service';
import { Router } from '@angular/router';
import { UserSearch } from '../../../models/user-search';
import { PagedDataResult } from '../../../models/paged-data-result';
import { UserCount } from '../../../models/user-count';
import moment from 'moment';
import { SubscriptionLevels } from '../../../models/subscription-levels';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbPagination],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  recentUsers: PagedDataResult<any>;
  pageSize: number = 15;
  page: number = 1;
  userKeyword: string = '';
  userCountToday: number = 0;
  userCountThisWeek: number = 0;
  userCountThisMonth: number = 0;
  userSubscriptionLevels: string = '';
  userSearchPreset: string = '';

  userCountTodayTrial: number = 0;
  userCountThisWeekTrial: number = 0;
  userCountThisMonthTrial: number = 0;

  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(private modalService: NgbModal,
    private eventBroadcastService: EventBroadcastService,
    private protuneApiService: ProtuneApiService,
    private router: Router) {
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      map((e: any) => e.target.value), 
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      this.resetUserSearch();
      this.searchInput.nativeElement.value = value;
      this.userKeyword = value;
      this.searchUsers();
    });

    this.getRecentUsers();
    this.getUserCounts();
  }

  private resetUserSearch() {
    this.searchInput.nativeElement.value = '';
    this.userKeyword = '';
    this.userSubscriptionLevels = '';
    this.page = 1;
    this.userSearchPreset = '';
  }

  getRecentUsers() {
    this.resetUserSearch();
    this.userSearchPreset = 'recentUsers';
    this.searchUsers();
  }

  getTrialUsers() {
    this.resetUserSearch();
    this.userSubscriptionLevels = 'Trial';
    this.userSearchPreset = 'trialUsers';
    this.searchUsers();
  }

  getUserCounts() {
    var today = moment().startOf('day');
    var week = moment().startOf('week');
    var month = moment().startOf('month');

    var todayParams = new UserCount();
    var thisWeekParams = new UserCount();
    var thisMonthParams = new UserCount();

    todayParams.createdStartDate = today.toDate();
    thisWeekParams.createdStartDate = week.toDate();
    thisMonthParams.createdStartDate = month.toDate();

    todayParams.subscriptionLevels = `${SubscriptionLevels.Lite},${SubscriptionLevels.Advanced}`;
    thisWeekParams.subscriptionLevels = `${SubscriptionLevels.Lite},${SubscriptionLevels.Advanced}`;
    thisMonthParams.subscriptionLevels = `${SubscriptionLevels.Lite},${SubscriptionLevels.Advanced}`;

    this.protuneApiService.getUserCount(todayParams).subscribe({
      next: res => {
        this.userCountToday = res;
      }, error: err => console.log(err)
    });

    this.protuneApiService.getUserCount(thisWeekParams).subscribe({
      next: res => {
        this.userCountThisWeek = res;
      }, error: err => console.log(err)
    });

    this.protuneApiService.getUserCount(thisMonthParams).subscribe({
      next: res => {
        this.userCountThisMonth = res;
      }, error: err => console.log(err)
    });

    //users in trial mode
    todayParams.subscriptionLevels = SubscriptionLevels.Trial;
    thisWeekParams.subscriptionLevels = SubscriptionLevels.Trial;
    thisMonthParams.subscriptionLevels = SubscriptionLevels.Trial;

    this.protuneApiService.getUserCount(todayParams).subscribe({
      next: res => {
        this.userCountTodayTrial = res;
      }, error: err => console.log(err)
    });

    this.protuneApiService.getUserCount(thisWeekParams).subscribe({
      next: res => {
        this.userCountThisWeekTrial = res;
      }, error: err => console.log(err)
    });

    this.protuneApiService.getUserCount(thisMonthParams).subscribe({
      next: res => {
        this.userCountThisMonthTrial = res;
      }, error: err => console.log(err)
    });
  }

  navigateToUserDetail(userId: string) {
    this.router.navigate(['/admin/user-detail'], { state: { userId: userId} });
  }

  searchUsers() {
    var userSearch = new UserSearch();

    userSearch.page = this.page;
    userSearch.pageSize = this.pageSize;
    userSearch.sortColumn = this.userKeyword ? 'UserName' : 'Created';
    userSearch.sortDirection = this.userKeyword ? 'asc' : 'desc';
    userSearch.search = this.userKeyword ? this.userKeyword : '';
    userSearch.subscriptionLevels = this.userSubscriptionLevels;


    this.protuneApiService.getUsers(userSearch).subscribe({
      next: res => {
        this.recentUsers = res;
      }, error: err => console.log(err)
    });
  }

  exportUsers() {
    const userSearch = new UserSearch();
    userSearch.sortColumn = this.userKeyword ? 'UserName' : 'Created';
    userSearch.sortDirection = this.userKeyword ? 'asc' : 'desc';
    userSearch.search = this.userKeyword ? this.userKeyword : '';
    userSearch.subscriptionLevels = this.userSubscriptionLevels;

    this.protuneApiService.exportUsers(userSearch).subscribe({
      next: blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `users-export-${moment().format('YYYYMMDDHHmmss')}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
      }, error: err => console.log(err)
    });
  }
}
